import { gtm_shop_item_ecommerce_event } from '.'

/**
 * Sends a GA4 recommended begin_checkout event.
 * @see https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#initiate_the_checkout_process
 *
 */
const gtm_begin_checkout = () => {
  gtm_shop_item_ecommerce_event('begin_checkout')
}

export default gtm_begin_checkout
